import { formatMoney } from '../../utils/currencyFormatter';

export const PE_PROFIT_BETRIEBSKOSTEN_KEYS = [
    { key: 'raumkosten', label: 'Raumkosten' },
    { key: 'betriebssteuern', label: 'Betriebliche Steuern' },
    { key: 'versicherungen', label: 'Versicherungen/Beiträge' },
    { key: 'besondereKosten', label: 'besondere Kosten' },
    { key: 'kfzKosten', label: 'KFZ Kosten' },
    { key: 'werbeReisekosten', label: 'Werbe/Reisekosten' },
    { key: 'warenabgabe', label: 'Warenabgabe an MA' },
    { key: 'reparatur', label: 'Reparatur/Instandhaltung' },
    { key: 'sonstigeKosten', label: 'sonstige Kosten' },
    { key: 'kredite', label: 'Kredite, Zinsen u.ä.' },
    { key: 'zinsaufwendungen', label: 'Zinsaufwendungen' },
    { key: 'gewerbesteuer', label: 'Gewerbesteuer' },
    { key: 'koerperschaftssteuer', label: 'Körperschaftssteuer (GmbH)' },
    { key: 'budgetPlansumme', label: 'Budget Plansumme' },
    { key: 'sonstigeEintrag1', labelKey: 'sonstigeEintrag1_label', fallback: 'sonstige Einträge' },
    { key: 'sonstigeEintrag2', labelKey: 'sonstigeEintrag2_label', fallback: 'sonstige Einträge' },
    { key: 'sonstigeEintrag3', labelKey: 'sonstigeEintrag3_label', fallback: 'sonstige Einträge' },
    { key: 'sonstigeEintrag4', labelKey: 'sonstigeEintrag4_label', fallback: 'sonstige Einträge' },
    { key: 'geraetekosten', label: 'Gerätekosten' },
    { key: 'abschreibungen', label: 'Abschreibungen' },
    { key: 'sonstigeEinnahmen', label: 'Sonstige Einnahmen' },
    { key: 'preisExpert', label: 'PreisExpert Beratung' },
] as const;

export interface BwaBetriebskostenOption {
    bwaKey: string;
    label: string;
    displayLabel: string;
}

const defaultFormatCurrency = (value: number): string =>
    formatMoney(Math.round(value || 0), 'EUR', 0);

export const getBwaJahreswert = (bwaKey: string, bwaData: Record<string, unknown> = {}): number => {
    if (bwaKey === 'sonstigeEinnahmen') {
        const sonstige = bwaData.sonstigeEinnahmen ?? bwaData.zinsenMiete;
        return Number(sonstige) || 0;
    }
    return Number(bwaData[bwaKey] ?? 0) || 0;
};

export const getBwaAnzeigewert = (
    bwaKey: string,
    bwaData: Record<string, unknown> = {},
    ansichtsModus: 'monat' | 'jahr' = 'monat',
    zeitraum = 12
): number => {
    const jahreswert = getBwaJahreswert(bwaKey, bwaData);
    if (ansichtsModus === 'jahr') {
        return Math.round(jahreswert);
    }
    const period = zeitraum > 0 ? zeitraum : 12;
    return Math.round(jahreswert / period);
};

export const resolveBwaBetriebskostenOptions = (
    bwaData: Record<string, unknown> = {},
    formatCurrency: (value: number) => string = defaultFormatCurrency,
    ansichtsModus: 'monat' | 'jahr' = 'monat',
    zeitraum = 12
): BwaBetriebskostenOption[] =>
    PE_PROFIT_BETRIEBSKOSTEN_KEYS.map((field) => {
        const label =
            'labelKey' in field && field.labelKey
                ? String(bwaData[field.labelKey] || field.fallback)
                : field.label;
        const anzeigewert = getBwaAnzeigewert(field.key, bwaData, ansichtsModus, zeitraum);
        return {
            bwaKey: field.key,
            label,
            displayLabel: `${label} (${formatCurrency(anzeigewert)})`,
        };
    }).filter((option) => getBwaJahreswert(option.bwaKey, bwaData) !== 0);
